import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Layout from './components/Layout';
import AnalyticsTracker from './AnalyticsTracker';
import HomePage from './pages/HomePage';
import BeautifierPage from './pages/BeautifierPage';
import JsonEscapeUnescapePage from './pages/JsonEscapeUnescapePage';
import JsonToSchemaPage from './pages/JsonToSchemaPage';
import SchemaValidatorPage from './pages/SchemaValidatorPage';
import JsonPathFinderPage from './pages/JsonPathFinderPage';
import JsonComparePage from './pages/JsonComparePage';
import CsharpToJsonPage from './pages/CsharpToJsonPage';
import LetterCountPage from './pages/LetterCountPage';
import XCounterPage from './pages/XCounterPage';
import HtmlBeautifierPage from './pages/HtmlBeautifierPage';
import HtmlViewerPage from './pages/HtmlViewerPage';
import HtmlEscapeUnescapePage from './pages/HtmlEscapeUnescapePage';
import DummyFilesPage from './pages/DummyFilesPage';
import DummyImagesPage from './pages/DummyImagesPage';
import DummyPDFPage from './pages/DummyPDFPage';
import HttpStatusCheckerPage from './pages/HttpStatusCheckerPage';
import QrCodeGeneratorPage from './pages/QrCodeGeneratorPage';
import RegexTesterPage from './pages/RegexTesterPage';
import TextDiffCheckerPage from './pages/TextDiffCheckerPage';
import TextReplacerPage from './pages/TextReplacerPage';
import JavaScriptCompressorPage from './pages/JavaScriptCompressorPage';
import CssBeautifierPage from './pages/CssBeautifierPage';
import JwtDecoderPage from './pages/JwtDecoderPage';
import NotePadPage from './pages/NotePadPage';
import SitemapPage from './pages/SitemapPage';
import LoremIpsumPage from './pages/LoremIpsumPage';
import WheelSpinPage from './pages/WheelSpinPage';
import HashGeneratorPage from './pages/HashGeneratorPage';
import UuidGeneratorPage from './pages/UuidGeneratorPage';
import PasswordGeneratorPage from './pages/PasswordGeneratorPage';
import UrlEncoderPage from './pages/UrlEncoderPage';
import Base64EncoderPage from './pages/Base64EncoderPage';
import MarkdownViewerPage from './pages/MarkdownViewerPage';
// AI Pages
import JsonToToonPage from './pages/JsonToToonPage';
import TemplatePromptsPage from './pages/TemplatePromptsPage';
// SEO Pages
import WhatIsJsonPage from './pages/WhatIsJsonPage';
import WhatIsJsonUnescapePage from './pages/WhatIsJsonUnescapePage';
import WhatIsJsonEscapePage from './pages/WhatIsJsonEscapePage';
import WhatIsHtmlValidatorPage from './pages/WhatIsHtmlValidatorPage';
// 404 Page
import NotFoundPage from './pages/NotFoundPage';
// import './App.css'; // Henüz oluşturulmadı, App özelinde stiller için eklenebilir.

function App() {
  return (
    <Layout>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/json-beautifier" element={<BeautifierPage />} />
        <Route path="/json-escape-unescape" element={<JsonEscapeUnescapePage />} />
        <Route path="/json-to-schema" element={<JsonToSchemaPage />} />
        <Route path="/schema-validator" element={<SchemaValidatorPage />} />
        <Route path="/json-path-finder" element={<JsonPathFinderPage />} />
        <Route path="/json-compare" element={<JsonComparePage />} />
        <Route path="/csharp-to-json" element={<CsharpToJsonPage />} />
        <Route path="/letter-count" element={<LetterCountPage />} />
        <Route path="/x-counter" element={<XCounterPage />} />
        <Route path="/html-beautifier" element={<HtmlBeautifierPage />} />
        <Route path="/html-viewer" element={<HtmlViewerPage />} />
        <Route path="/html-escape-unescape" element={<HtmlEscapeUnescapePage />} />
        <Route path="/dummy-files" element={<DummyFilesPage />} />
        <Route path="/dummy-files/images" element={<DummyImagesPage />} />
        <Route path="/dummy-files/pdf" element={<DummyPDFPage />} />
        <Route path="/http-status-checker" element={<HttpStatusCheckerPage />} />
        <Route path="/qr-code-generator" element={<QrCodeGeneratorPage />} />
        <Route path="/regex-tester" element={<RegexTesterPage />} />
        <Route path="/text-diff-checker" element={<TextDiffCheckerPage />} />
        <Route path="/text-replacer" element={<TextReplacerPage />} />
        <Route path="/javascript-compressor" element={<JavaScriptCompressorPage />} />
        <Route path="/css-compressor" element={<CssBeautifierPage />} />
        <Route path="/jwt-decoder" element={<JwtDecoderPage />} />
        <Route path="/notepad" element={<NotePadPage />} />
        <Route path="/sitemap" element={<SitemapPage />} />
        <Route path="/lorem-ipsum" element={<LoremIpsumPage />} />
        <Route path="/wheel-spin" element={<WheelSpinPage />} />
        <Route path="/hash-generator" element={<HashGeneratorPage />} />
        <Route path="/uuid-generator" element={<UuidGeneratorPage />} />
        <Route path="/password-generator" element={<PasswordGeneratorPage />} />
        <Route path="/url-encoder" element={<UrlEncoderPage />} />
        <Route path="/base64-encoder" element={<Base64EncoderPage />} />
        <Route path="/markdown-viewer" element={<MarkdownViewerPage />} />
        {/* AI Pages */}
        <Route path="/json-to-toon" element={<JsonToToonPage />} />
        <Route path="/template-prompts" element={<TemplatePromptsPage />} />
        {/* SEO Pages - Not in navigation, only in sitemap */}
        <Route path="/what-is-json" element={<WhatIsJsonPage />} />
        <Route path="/what-is-json-unescape" element={<WhatIsJsonUnescapePage />} />
        <Route path="/what-is-json-escape" element={<WhatIsJsonEscapePage />} />
        <Route path="/what-is-html-validator" element={<WhatIsHtmlValidatorPage />} />
        {/* 404 Page - Must be last */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Analytics />
      <SpeedInsights />
    </Layout>
  );
}

export default App; 
